import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { FileService } from '@ipg/ngx-frontend-toolset';
import { AvatarComponent } from '../../../../../../components/avatar/avatar.component';
import { ImageAction } from '../../../../../../models/interactions.model';
import { FlowActionCardComponent } from '../flow-action-card/flow-action-card.component';

@Component({
  selector: 'app-flow-image-action',
  imports: [FlowActionCardComponent, AvatarComponent, MatIcon, MatTooltip],
  templateUrl: './flow-image-action.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlowImageActionComponent {
  private readonly _fileService = inject(FileService);

  readonly data = input.required<ImageAction>();

  protected readonly imageUrl = computed(
    () => this._fileService.get(this.data().value.fileId).href,
  );
}
